export const ADMIN_AREA_PREFIX = '/admin';
const SHARED_AUTH_PREFIX = '/auth';
const SHARED_UNAUTHORIZED_PATH = '/unauthorized';

export function isAdminAreaPath(pathname: string): boolean {
  return pathname === ADMIN_AREA_PREFIX || pathname.startsWith(`${ADMIN_AREA_PREFIX}/`);
}

export function withAreaPrefix(path: string, pathname: string): string {
  if (!path.startsWith('/')) return path;
  if (path === SHARED_UNAUTHORIZED_PATH || path.startsWith(`${SHARED_AUTH_PREFIX}/`)) {
    return path;
  }
  if (!isAdminAreaPath(pathname)) return path;
  return path.startsWith(ADMIN_AREA_PREFIX) ? path : `${ADMIN_AREA_PREFIX}${path}`;
}
